<template>
  <div class="app-main-content">
    <div class="grid-view">
      <div class="main-content">
        <search-item
          config-module="300301"
          :custom-sim-query-placeholder="$t('RailwayExport.Prompt2')"
          @click-more="value=>filter.isAdvancedQuery=value"
          @simSearchItemCallBack="toSimpleQuery"
          @advSearchItemCallBack="toAdvancedQuery"
          @advSearchItemResetCallBack="toAdvancedQuery"
        />
        <div class="section grid-wrapper">
          <cargo-ag-grid
            :grid-params.sync="gridParams"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
          />
        </div>
        <div class="pagination-wrapper">
          <cargo-pagination
            :total="filter.total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="toQuery()"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import ColumnUtils from '@/utils/ColumnUtils'
import cargoLeftRightResize from '@/components/Cargo/Common/cargoLeftRightResize'
import { getLoading } from '@/utils/utilBaseElement'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as BoxTubeConstants from '@/class/cargo/model/parameters/BoxTubeConstants'
import * as railwayContainerApi from '@/api/railwayExport/railwayContainer'
import { exportExcel, exportPdf } from '@/utils/tableDataExportUtils'

export default {
  name: 'QueryContainer',
  components: { searchItem, cargoLeftRightResize },
  data() {
    return {
      gridParams: {},
      gridApi: null,
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        suppressRowClickSelection: false,
        onCellFocused: event => {
          this.selectedRowIndex = event.rowIndex
        },
        suppressContextMenu: false, // 右键列表弹出菜单
        getContextMenuItems: (params) => {
          const self = this
          return [
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('RailwayExport.CurrentlySelected'),
              action: function() {
                self.exportExcelSelectedHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_ExcelExport') + this.$t('RailwayExport.CurrentPage'),
              action: function() {
                self.exportExcelHandler()
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('RailwayExport.CurrentlySelected'),
              action: function() {
                self.exportPdfSelectedHandler(params)
              }
            },
            {
              name: self.$t('CargoMsg.Cargo_DataExportPDF') + this.$t('RailwayExport.CurrentPage'),
              action: function() {
                self.exportPdfHandler(params)
              }
            }
          ]
        }
      },
      columnDefs: [
        {
          headerName: '',
          field: '',
          width: 65,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        { headerName: this.$t('RailwayExport.OrderNo'), field: 'ORDER_NO', width: 120 },
        { headerName: this.$t('RailwayExport.ContainerNo'), field: 'CONTAINERNO', width: 120 },
        { headerName: this.$t('RailwayExport.EQSize'), field: 'EQSIZE', width: 120 },
        { headerName: this.$t('RailwayExport.EQType'), field: 'EQTYPE', width: 120 },
        { headerName: this.$t('RailwayExport.BoxOwner'), field: 'SELLER_NAME', width: 200 },
        { headerName: this.$t('RailwayExport.OrderType'), field: 'ORDER_TYPE', width: 120,
          cellRenderer: params => BoxTubeConstants.orderTypeFunction(Number(params.value))
        },
        { headerName: this.$t('RailwayExport.ContainerStatus'), field: 'CONTAINER_STATUS', width: 120,
          cellRenderer: params => this.containerStatusFunction(Number(params.value))
        },
        { headerName: this.$t('RailwayExport.JobNo2'), field: 'JOB_NO', width: 120 },
        { headerName: this.$t('RailwayExport.ConsignationCompany'), field: 'CUSTOMER_ID', width: 120,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('RailwayExport.Amount'), field: 'AMOUNT', width: 120 },
        { headerName: this.$t('RailwayExport.CurrencyCode'), field: 'CURRENCY_CODE', width: 120 },
        { headerName: this.$t('RailwayExport.BuyerTime'), field: 'BUYER_DATE', width: 120,
          cellRenderer: params => ColumnUtils.dateColumnLabelFunc(params.value)
        },
        { headerName: this.$t('RailwayExport.RentDate'), field: 'RENT_DATE', width: 120,
          cellRenderer: params => ColumnUtils.dateColumnLabelFunc(params.value)
        },
        { headerName: this.$t('RailwayExport.ReturnTime'), field: 'RETURN_DATE', width: 120,
          cellRenderer: params => ColumnUtils.dateColumnLabelFunc(params.value)
        },
        { headerName: this.$t('RailwayExport.OperationTime'), field: 'DATE_CREATED', width: 200 }
      ],
      rowData: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 30
      },
      conditions: {} // 查询条件
    }
  },
  computed: {},
  created() {
  },
  methods: {
    // 简单查询
    toSimpleQuery(data) {
      this.conditions = { containerNo: data, conditions: [] }
      this.filter.pageSize = 30
      this.filter.pageNum = 1
      this.toQuery()
    },
    // 高级查询
    toAdvancedQuery(conditions) {
      const params = {}
      params.conditions = conditions || []
      this.conditions = params
      this.filter.pageSize = 30
      this.filter.pageNum = 1
      this.toQuery()
    },
    // 查询
    toQuery() {
      const filter = this.conditions
      filter.pageSize = this.filter.pageSize > 0 ? this.filter.pageSize : 30
      filter.pageNum = this.filter.pageNum > 0 ? this.filter.pageNum : 1
      const loading = getLoading()
      railwayContainerApi.queryContainerList(filter).then(resp => {
        this.querySuccessHandler(resp)
      }).finally(() => loading.close())
    },
    querySuccessHandler(resp) {
      const data = resp.data
      if (data) {
        this.filter.total = Number(data.total)
        this.filter.pageNum = data.pageNum
        this.rowData = resp.data.list
      }
    },
    containerStatusFunction(containerStatus) {
      if (containerStatus === 1) {
        return this.$t('RailwayExport.CurrentlyAvailable')
      } else if (containerStatus === 2) {
        return this.$t('RailwayExport.CurrentlyOccupied')
      } else if (containerStatus === 3) {
        return this.$t('RailwayExport.Sold')
      }
      return ''
    },
    exportExcelSelectedHandler() {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportExcelHandler(rows)
    },
    exportExcelHandler(rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = []
      this.columnDefs.forEach(column => columnDefs.push({ colDef: column }))
      exportExcel(this.$t('RailwayExport.ContainerInquiry'), rowData, columnDefs)
    },
    exportPdfSelectedHandler(params) {
      const rows = this.gridOptions.api.getSelectedRows()
      this.exportPdfHandler(params, rows)
    },
    exportPdfHandler(params, rows) {
      const rowData = rows || this.rowData
      if (!rowData || rowData.length === 0) return
      const columnDefs = params.columnApi.getAllDisplayedColumns()
      exportPdf(this.$t('RailwayExport.ContainerInquiry'), rowData, columnDefs)
    }
  }
}
</script>

<style scoped>

</style>
